module.exports = __webpack_public_path__ + "static/media/user-white.b9b334f7.svg";